<h5 class="mb-4">
  <strong>Basic Usage</strong>
</h5>
<div class="mb-5">
  <ngb-timepicker [(ngModel)]="time"></ngb-timepicker>
  <hr>
  <pre>Selected time: {{time | json}}</pre>
</div>